import React, { lazy, Suspense } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./assets/GlobalStyle.css";

import ReactDOM from "react-dom";
import { SpinnerComponent } from "./components/Spinner";
import AuthProvider from "./context/AuthContext";
import "./index.css";
import GoogleTranslate from "./components/GoogleTranslate";

const LazyApp = lazy(() => import("./App"));

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <Suspense fallback={<SpinnerComponent />}>
      <GoogleTranslate/>
        <LazyApp />
      </Suspense>
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
